<template>
  <div>
    <h3 class="title dw_green--text font-weight-light">
      <v-icon color="dw_green" class="mr-2 mb-1" v-text="mdiCompassOutline" />
      Existing Objectives
    </h3>
    <v-row no-gutters>
      <v-col cols="11">
        <v-text-field
          v-model="search"
          @change="searchExisting"
          @click:clear="search = ''; searchExisting()"
          label="Search Objectives"
          :append-icon="mdiMagnify"
          color="dw_green"
          hide-details
          clearable
        ></v-text-field>
      </v-col>
    </v-row>
    <v-card width="33vw" max-height="50vh" class="pa-2 my-2 existing-list">
      <p v-for="objctv of objectives" :key="objctv" class="grey--text caption mb-1">{{ objctv }}</p>
    </v-card>
  </div>
</template>

<script>
import { mdiCompassOutline, mdiMagnify } from '@mdi/js';
import { mapGetters } from 'vuex';

export default {
  name: 'objectiveList',
  data() {
    return {
      mdiCompassOutline,
      mdiMagnify,
      search: '',
      objectives: []
    }
  },
  computed: {
    ...mapGetters([
      'objectiveOptions'
    ])
  },
  mounted() {
    this.objectives = this.objectiveOptions.map((objective) => objective.title);
  },
  methods: {
    searchExisting() {
      this.objectives = this.objectiveOptions.map((objective) => objective.title);
      if (this.search !== '') {
        this.objectives = this.objectives.filter((objective) => {
          const s = this.search.toLowerCase();
          return objective.toLowerCase().includes(s);
        });
      }
    }
  }
};
</script>

<style scoped>
.existing-list {
  height: inherit;
  overflow-y: scroll;
}
</style>
